import { useEffect } from 'react'

const DeclarationsQuestion = ({ requestData, setRequestData, formData, setFormData, validationErrors = [] }) => {
    useEffect(() => {
        if (!formData.declarations) {
            setFormData(prevFormData => ({
                ...prevFormData,
                declarations: {
                    purpose_explained: false,
                    questions_aware: false,
                    abandonment: false
                }
            }))
        }
    }, [formData.declarations])

    return (
        <div className="mt-6 border border-gray-200 rounded-lg">
            <div className="flex items-center justify-between p-4 bg-blue-50 rounded-t-lg">
                <h2 className="text-lg font-semibold text-gray-800">
                    Step 9: Employer Consent
                </h2>
                <div className="flex items-center">
                    <span className="text-red-500 text-sm font-medium mr-2">Required *</span>
                </div>
            </div>
            <div className="p-4">
                {(validationErrors.includes('purpose_explained') || validationErrors.includes('questions_aware') || validationErrors.includes('abandonment')) && (
                    <div className="bg-red-50 border-l-4 border-red-400 p-3 mb-4">
                        <div className="flex">
                            <div className="flex-shrink-0">
                                <svg className="h-5 w-5 text-red-400" viewBox="0 0 20 20" fill="currentColor">
                                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
                                </svg>
                            </div>
                            <div className="ml-3">
                                <p className="text-sm text-red-700">
                                    Please check all required declarations to continue.
                                </p>
                            </div>
                        </div>
                    </div>
                )}
                <div className="text-sm text-gray-700 mb-4">
                    <p className="mb-2">The primary purpose of this assessment is to:</p>
                    <ul className="list-disc pl-5 space-y-1">
                        <li>Provide independent and impartial advice to my Employer regarding my fitness for work</li>
                        <li>Assess the potential effect of my work on my health, and vice versa.</li>
                        <li>Suggest any adjustments or support measures for my Employer to consider in line with the Equality Act 2010</li>
                        <li>Advise on any estimated timescales for my return to work duties, if applicable</li>
                    </ul>
                </div>

                <div className="space-y-3">
                    <div className={`flex items-start ${validationErrors.includes('purpose_explained') ? 'bg-red-50 border border-red-200 rounded-md p-3' : ''}`}>
                        <input
                            type="checkbox"
                            id="purpose_explained"
                            checked={formData.declarations.purpose_explained}
                            onChange={(e) => {
                                const newValue = e.target.checked
                                setFormData({
                                    ...formData,
                                    declarations: {
                                        ...formData.declarations,
                                        purpose_explained: newValue
                                    }
                                })
                            }}
                            required
                            className="mt-1 mr-3"
                        />
                        <label htmlFor="purpose_explained" className="text-sm text-gray-700">
                            I confirm that the reason and purpose of this Occupational Health referral have been explained to the employee by the Employer. <span className="text-red-500">*</span>
                        </label>
                    </div>

                    <div className={`flex items-start ${validationErrors.includes('questions_aware') ? 'bg-red-50 border border-red-200 rounded-md p-3' : ''}`}>
                        <input
                            type="checkbox"
                            id="questions_aware"
                            checked={formData.declarations.questions_aware}
                            onChange={(e) => {
                                const newValue = e.target.checked
                                setFormData({
                                    ...formData,
                                    declarations: {
                                        ...formData.declarations,
                                        questions_aware: newValue
                                    }
                                })
                            }}
                            required
                            className="mt-1 mr-3"
                        />
                        <label htmlFor="questions_aware" className="text-sm text-gray-700">
                            I confirm that the employee is aware of the questions asked to Occupational Health and that the report will include responses to these questions. <span className="text-red-500">*</span>
                        </label>
                    </div>

                    <div className={`flex items-start ${validationErrors.includes('abandonment') ? 'bg-red-50 border border-red-200 rounded-md p-3' : ''}`}>
                        <input
                            type="checkbox"
                            id="abandonment"
                            checked={formData.declarations.abandonment}
                            onChange={(e) => {
                                const newValue = e.target.checked
                                setFormData({
                                    ...formData,
                                    declarations: {
                                        ...formData.declarations,
                                        abandonment: newValue
                                    }
                                })
                            }}
                            required
                            className="mt-1 mr-3"
                        />
                        <label htmlFor="abandonment" className="text-sm text-gray-700">
                            I am aware that if the employee is not aware of the reasons for the Occupational Health referral or the questions listed by their employer, the assessment may have to be abandoned and the appointment will be charged. <span className="text-red-500">*</span>
                        </label>
                    </div>
                </div>

                <div className="text-xs mt-4">
                    <span className="text-red-500">*</span> Denotes required fields.
                </div>
            </div>
        </div>
    );
};

export default DeclarationsQuestion;